module.exports = {
  WinName: '选择模板',
  TemplateName: '模板名称',
  OK: '确认',
  Cancel: '取消',
  QueryTemplateFailed: '查询模板失败！',
  Tips: '提示',
  PlsSelectTemplate: '请选择一个模板！',
  Copy: '复制',
  TemplateTypes: '模板类型',
  EmailTemp: '显示邮件模板',
  viewV3: '显示V3模板',
  inputTemplateName: '模板名称录入',
  notFoundTemplate: '没有找到对应类型的模板，请先添加模板！',
  batchPrintMore: '批量打印数据量超过{0}条（系统上限），系统无法加载，请联系在线客服！',
  noSchemaType: 'SchemaType未维护！',
  printMore: '打印记录数超过‘100’条，加载时间可能较长，是否继续打印？',
  notFoundTemplateFromData: '未找到模板【{0}】，请检查模板！',
  notEmptyTemplateName: '模板名称不能为空！',
  hasFoundTemplateName: '模板名称已存在！',
  attachmentLarge: '附件内容过大！',
  smtpServerError: 'SMTP服务器错误！',
  unConnectSmtp: '不能连接SMTP服务器！',
  notFoundFile: '系统找不到指定文件！',
  fileSendError: '发送文件出错！',
  attachmentTemplateError: '附件模板出错！',
  sendEmailSuccess: '邮件发送成功！'
}
